import { FabricObject, StaticCanvas } from 'fabric';
import { walkObjects } from './walk-objects';

/** Indexes canvas objects by pieceId. */
export function buildPieceIdIndex(canvas: StaticCanvas): Map<string, FabricObject> {
  const index = new Map<string, FabricObject>();

  walkObjects(canvas, obj => {
    const pid = obj.pieceId;
    if (pid && !index.has(pid)) index.set(pid, obj);
  });

  return index;
}

// A pieceId must be unique: the index keeps the first, so a duplicate is invisible to the form.
export function findDuplicatePieceIds(canvas: StaticCanvas): string[] {
  const seen = new Set<string>();
  const duplicates = new Set<string>();
  walkObjects(canvas, obj => {
    const pid = obj.pieceId;
    if (!pid) return;
    if (seen.has(pid)) duplicates.add(pid);
    seen.add(pid);
  });
  return Array.from(duplicates);
}
